var _style, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMechanicDisconnector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svgcontent",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.mechanicDisconnector-st0{fill:#FFFFFF;stroke:currentColor;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svg_2_00000130613408427941699760000004692605645420429959_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 33.4,
    className: "mechanicDisconnector-st0",
    width: 72.9,
    height: 12.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9,33.9v11.8H4.1V33.9H75.9 M76.9,32.9H3v13.8h73.9V32.9L76.9,32.9z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.5,47.7h-21c-0.3,0-0.5-0.2-0.5-0.5V32.3c0-0.3,0.2-0.5,0.5-0.5h21c0.3,0,0.5,0.2,0.5,0.5v14.9 C76.9,47.5,76.7,47.7,76.5,47.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMechanicDisconnector);
export default __webpack_public_path__ + "static/media/mechanicDisconnector.f18ecc980fd5a6e393c1ee532a7b2617.svg";
export { ForwardRef as ReactComponent };